import React from 'react'
import {Stack, Typography} from '@mui/material'
import ArrowUpwardRoundedIcon from '@mui/icons-material/ArrowUpwardRounded'
import ArrowDownwardRoundedIcon from '@mui/icons-material/ArrowDownwardRounded'
import {useTheme} from '@mui/material/styles'

/**
 * Shows a change with an arrow. `goodWhen` decides the color: consumption going up is neither
 * good nor bad ('neutral'), a success rate going up is good ('up').
 */
const DeltaBadge = ({value, suffix = '%', goodWhen = 'neutral', label}) => {
    const {palette} = useTheme()
    if (value === null || value === undefined || !Number.isFinite(value)) return null

    const rounded = Math.abs(value) < 0.05 ? 0 : value
    let color = palette.text.secondary
    if (goodWhen !== 'neutral' && rounded !== 0) {
        const isGood = goodWhen === 'up' ? rounded > 0 : rounded < 0
        color = isGood ? palette.success.main : palette.error.main
    }
    const Icon = rounded < 0 ? ArrowDownwardRoundedIcon : ArrowUpwardRoundedIcon

    return (
        <Stack direction="row" spacing={0.5} alignItems="center" flexWrap="wrap">
            <Stack direction="row" alignItems="center" sx={{color}}>
                {rounded !== 0 && <Icon sx={{fontSize: 16}} />}
                <Typography variant="caption" fontWeight={700} sx={{color}}>
                    {Math.abs(rounded).toFixed(1)}
                    {suffix}
                </Typography>
            </Stack>
            {label && (
                <Typography variant="caption" color="text.secondary">
                    {label}
                </Typography>
            )}
        </Stack>
    )
}

export default DeltaBadge
